import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import TrackingLinkForm from '../components/TrackingLinkForm/TrackingLinkForm';
import { actions } from '../../broker/redux/brokerActions';
import Loader from '../../../common/components/Loader/Loader';
import InternalContainer from '../../../modules/layout/containers/Internal';
import { actions as trackingLinkActions } from '../redux/trackingLinkActions';

const TrackingLinkEditContainer = ({
  params,
  onGetAllProducts,
  onGetBroker,
  onUpdateTrackingLinkBroker,
}) => {
  const id = params.id;
  useEffect(
    () => {
      onGetBroker(id);
      onGetAllProducts();
    },
    [id, onGetBroker, onGetAllProducts],
  );

  const save = (resource) => {
    return onUpdateTrackingLinkBroker(resource);
  };

  const resource = useSelector((state) => state.broker.resources?.[id]);

  if (!resource) {
    return (
      <InternalContainer>
        <Loader />
      </InternalContainer>
    );
  }

  return (
    <InternalContainer>
      <TrackingLinkForm resource={resource} onSave={save} />
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    onGetBroker: actions.getBroker,
    onGetAllProducts: actions.getAllProducts,
    onUpdateTrackingLinkBroker: trackingLinkActions.updateTrackingLinkBroker,
  },
)(TrackingLinkEditContainer);
